<template>
	<Row class="page-container-row">
		<Col :span="24" :offset="0">
			<PageContainer>
				<Row :gutter="[16, 8]">
					<Col :span="24">
						<TypographyTitle :level="2">{{ $t('account.header') }}</TypographyTitle>
					</Col>
				</Row>
				<Row :gutter="[16, 8]">
					<ChangePasswordForm />
					<GenerateCasterPasswordForm />
					<template v-if="allowExternalApiKeyManagement">
						<Divider />
						<ExternalApiKeys />
					</template>
					<LinkedTelegrams v-if="telegramAlertsEnabled" />
					<Divider />
					<LinkedEmails />
				</Row>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { computed } from 'vue';
import { Row, Col, TypographyTitle, Divider } from 'ant-design-vue';

import { useAccessStore } from '@/stores/access';
import { useUserStore } from '@/stores/user';

import PageContainer from '@/components/common/PageContainer';
import ChangePasswordForm from '@/components/account/ChangePasswordForm';
import GenerateCasterPasswordForm from '@/components/account/GenerateCasterPasswordForm';
import ExternalApiKeys from '@/components/account/ExternalApiKeys.vue';
import LinkedTelegrams from '@/components/account/LinkedTelegrams';
import LinkedEmails from '@/components/account/LinkedEmails';


export default {
	components: {
		Row, Col, TypographyTitle, Divider,
		PageContainer, ChangePasswordForm, GenerateCasterPasswordForm, ExternalApiKeys, LinkedTelegrams, LinkedEmails,
	},
	setup() {
		const telegramAlertsEnabled = computed(() => useAccessStore().telegramAlertsEnabled);
		const allowExternalApiKeyManagement = computed(() => useUserStore().allowExternalApiKeyManagement);
		return {
			telegramAlertsEnabled,
			allowExternalApiKeyManagement,
		};
	},
}
</script>
